import BaseController from './BaseController';

export const GLOBAL_CONTROLLER_ID = 'GlobalController';

/**
 * Basic controller for running arbitrary things on a page.
 */
export default class GlobalController extends BaseController {
  /**
   * @see BaseController._baseId
   */
  static _baseId = GLOBAL_CONTROLLER_ID;

  /**
   * Initialize base controller.
   */
  _init() {
    this._initBase();
  }

  /**
   * Called on load, trigger load in base controller.
   */
  _load() {
    this._loadBase();
  }

  /**
   * Called on turbolinks:load except on first page load.
   */
  onNavigation() {
    // Override in subclass
  }
}
